import React, { useEffect, useState } from "react";
import axios from "axios";
import { MvcAPPURL } from "../../../Util/axios_helper";
import { KendoLoader } from "../../../Kendo/kendo_loader";
import { popup } from "leaflet";
import { ImageURL } from "../../../Util/axios_core_helper";

const InquiryPage = ({ InquiryModal, ResetModal }) => {
  const [Model, setmodel] = useState({});
  const [Loaded, setLoaded] = useState(0);

  const fetchInquiries = async () => {
    try {
      const response = await axios.get(`${MvcAPPURL}ContactUs/GetNewInquiry`);
      setmodel(response.data);
    } catch (err) {
      console.error("Error fetching data:", err);
    }
  };
  useEffect(() => {
    if (InquiryModal) {
      fetchInquiries();
      setLoaded(Loaded + 1);
    }
  }, [InquiryModal]);

  const calendlyLink = "https://calendly.com/info-14532";

  let now = new Date();
  let now2 = new Date();
  let now3 = new Date();
  let fieldValueArray = {};
  let ogfieldValueArray = {};
  let isvalueschanged = false;
  let IndextimesWrong = 0;
  var currentStep = 1;
  var showCalendly = false;
  let today = new Date();
  var WeddingfuncList = [];
  var inquiry;
  var contactuniqueId;
  var InquiryId;
  let timeoutId = 0;
  let IndexrandomNum1;
  let IndexrandomNum2;
  let IndexhumanNumber;
  let IndexrandomTotal;
  let Issuccess;

  function differentProblem() {
    var Attempt = IndextimesWrongPlural();

    if (Attempt == "1") {
      IndexrandomNum1 = Math.floor(Math.random() * 9 + 1);
      IndexrandomNum2 = Math.floor(Math.random() * 90 + 10);
    } else if (Attempt == "2") {
      IndexrandomNum1 = Math.floor(Math.random() * 90 + 10);
      IndexrandomNum2 = Math.floor(Math.random() * 90 + 10);
    } else if (Attempt == "3") {
      IndexrandomNum1 = Math.floor(Math.random() * 900 + 100);
      IndexrandomNum2 = Math.floor(Math.random() * 900 + 100);
    } else if (Attempt == "") {
      IndexrandomNum1 = Math.floor(Math.random() * 9 + 1);
      IndexrandomNum2 = Math.floor(Math.random() * 9 + 1);
    }

    $("#Indexrandom1").empty().append(IndexrandomNum1);
    $("#Indexrandom2").empty().append(IndexrandomNum2);
    $("#usernumber1").val("");
    $("#usernumber1").removeClass("input-validation-error");
  }

  function IndextimesWrongPlural() {
    if (IndextimesWrong == 1) {
      return "1";
    } else if (IndextimesWrong > 1 && IndextimesWrong <= 4) {
      return "2";
    } else if (IndextimesWrong > 4) {
      return "3";
    } else {
      return "";
    }
  }

  function oncloseModal() {
    $("#inquiry").modal("hide");
    var Email = $("#Email").val();
    var PhoneNo = $("#PhoneNo").val();
    if ((Email || PhoneNo) && isvalueschanged) {
      if (Object.keys(fieldValueArray).length > 0) {
        UnconditionalSave();
      }
    }
    //send SMS
    sendSMS();
    ResetModal();
  }

  function loadCalendar(dates, current) {
    var isUserNavigation = false;

    $("#div-calwrapper").html("");
    $("#div-calwrapper").append(
      $(
        '<div id="kendo-calendar" style="height:300px!important;overflow:hidden" >'
      )
    );

    var d = new Date();
    var firstDayOfMonth = new Date(d.getFullYear(), d.getMonth(), 1);

    var em = $("#div-calwrapper").find("#kendo-calendar");

    em.kendoCalendar({
      min: firstDayOfMonth,
      value: now,
      change: function (e) {
        let selval = this.value();
        let d = kendo.toString(selval, "MM/dd/yyyy");
        inquiry.EventDate = d;
        inquiry.StartDate = d;
        fieldValueArray["StartDate"] = d;
        fieldValueArray["EventDate"] = d;
        inquiry.BallroomNames = inquiry.RecommendedBallroom;
        showCalendly = true;
        isvalueschanged = true;
        inquiry.IsValuesChanged = true;
      },
      disableDates: function (date) {
        if (date && !compareDates(date, dates)) {
          return true;
        } else {
          return false;
        }
      },
      navigate: function (e) {
        if (isUserNavigation && now.getMonth() != this.current().getMonth()) {
          let currentMonth = this.current().getMonth() + 1;
          let currentYear = this.current().getUTCFullYear();
          var ballroomName = inquiry.RecommendedBallroom.split(" ")[0];

          $.ajax({
            url: `${MvcAPPURL}${"ContactUs/GetBRoomAvailableDates"}?Month=${currentMonth}&Year=${currentYear}&Ballroom=${ballroomName}`,
            type: "Get",
            success: function (response) {
              var newdate = new Date(
                currentYear,
                currentMonth - 1,
                d.getDate()
              );
              now = newdate;
              isUserNavigation = false;
              loadCalendar(response, newdate);
            },
            error: function (error) {
              console.error("Error:", error);
            },
          });
        } else {
          isUserNavigation = true;
        }
      },
    });
  }

  function Unavailable_loadCalendar(dates, current, index) {
    var isUserNavigation = false;

    $("#Unavailable_div-calwrapper").html("");
    $("#Unavailable_div-calwrapper").append(
      $(
        '<div id="Unavailable_kendo-calendar" style="height:300px!important;overflow:hidden" >'
      )
    );

    var d = new Date();
    var firstDayOfMonth = new Date(d.getFullYear(), d.getMonth(), 1);

    var em = $("#Unavailable_div-calwrapper").find(
      "#Unavailable_kendo-calendar"
    );

    em.kendoCalendar({
      min: firstDayOfMonth,
      value: now2,
      change: function (e) {
        let selval = this.value();
        let d = kendo.toString(selval, "MM/dd/yyyy");
        inquiry.InquiryFunctionTypeList[index].FunctionDate = d;
        showCalendly = true;
        inquiry.BallroomNames =
          inquiry.InquiryFunctionTypeList[index].firstPriorityBallroomName;
        inquiry.StartDate = d;
        inquiry.EventDate = d;
        fieldValueArray["StartDate"] = d;
        fieldValueArray["EventDate"] = d;
        isvalueschanged = true;
        inquiry.IsValuesChanged = true;
      },
      disableDates: function (date) {
        if (date && !compareDates(date, dates)) {
          return true;
        } else {
          return false;
        }
      },
      navigate: function (e) {
        if (isUserNavigation && now2.getMonth() != this.current().getMonth()) {
          let currentMonth = this.current().getMonth() + 1;
          let currentYear = this.current().getUTCFullYear();
          var ballroomName =
            inquiry.InquiryFunctionTypeList[
              index
            ].firstPriorityBallroomName.split(" ")[0];

          $.ajax({
            url: `${MvcAPPURL}${"ContactUs/GetBRoomAvailableDates"}?Month=${currentMonth}&Year=${currentYear}&Ballroom=${ballroomName}`,
            type: "Get",
            success: function (response) {
              var newdate = new Date(
                currentYear,
                currentMonth - 1,
                d.getDate()
              );
              now2 = newdate;
              isUserNavigation = false;
              Unavailable_loadCalendar(response, newdate, index);
            },
            error: function (error) {
              console.error("Error:", error);
            },
          });
        } else {
          isUserNavigation = true;
        }
      },
    });
  }

  function Unavailable_loadCalendar2(dates, current, index) {
    var isUserNavigation = false;

    $("#Unavailable_div-calwrapper1").html("");
    $("#Unavailable_div-calwrapper1").append(
      $(
        '<div id="Unavailable_kendo-calendar1" style="height:300px!important;overflow:hidden;" >'
      )
    );

    var d = new Date();
    var firstDayOfMonth = new Date(d.getFullYear(), d.getMonth(), 1);

    var em = $("#Unavailable_div-calwrapper1").find(
      "#Unavailable_kendo-calendar1"
    );

    em.kendoCalendar({
      min: firstDayOfMonth,
      value: now3,
      change: function (e) {
        let selval = this.value();
        let d = kendo.toString(selval, "MM/dd/yyyy");
        inquiry.StartDate = d;
        inquiry.EventDate = d;
        inquiry.InquiryFunctionTypeList[index].FunctionDate = d;
        showCalendly = true;
        fieldValueArray["StartDate"] = d;
        fieldValueArray["EventDate"] = d;
        isvalueschanged = true;
        inquiry.IsValuesChanged = true;
      },
      disableDates: function (date) {
        if (date && !compareDates(date, dates)) {
          return true;
        } else {
          return false;
        }
      },
      navigate: function (e) {
        if (isUserNavigation && now3.getMonth() != this.current().getMonth()) {
          let currentMonth = this.current().getMonth() + 1;
          let currentYear = this.current().getUTCFullYear();
          var ballroomName =
            inquiry.InquiryFunctionTypeList[
              index
            ].firstPriorityBallroomName.split(" ")[0];

          $.ajax({
            url: `${MvcAPPURL}${"ContactUs/GetBRoomAvailableDates"}?Month=${currentMonth}&Year=${currentYear}&Ballroom=${ballroomName}`,
            type: "Get",
            success: function (response) {
              var newdate = new Date(
                currentYear,
                currentMonth - 1,
                d.getDate()
              );
              now3 = newdate;
              isUserNavigation = false;
              Unavailable_loadCalendar2(response, newdate, index);
            },
            error: function (error) {
              console.error("Error:", error);
            },
          });
        } else {
          isUserNavigation = true;
        }
      },
    });
  }

  function compareDates(date, dates) {
    for (var i = 0; i < dates.length; i++) {
      var d = new Date(dates[i]);
      if (
        d.getUTCDate() == date.getUTCDate() &&
        d.getUTCMonth() == date.getUTCMonth() &&
        d.getUTCFullYear() == date.getUTCFullYear()
      ) {
        return true;
      }
    }
  }

  function MulDatefunchange(checkbox) {
    var isChecked = checkbox.checked;
    fieldValueArray["IsMultiDateEvent"] = isChecked ? true : false;
  }

  function Haveyoubeenchag(checkbox) {
    var isChecked = checkbox.checked;
    fieldValueArray["isRecently"] = isChecked ? true : false;
  }

  function storeNoOfAttendees(radio) {
    isvalueschanged = true;
    fieldValueArray["NoofAttendeesRange"] = radio.value;
    fieldValueArray["MaxAttendeesId"] = radio.getAttribute("data-id");
    if (
      radio.value == "" ||
      radio.value == null ||
      radio.value == "undefined"
    ) {
      $("#err_range").css("display", "");
    } else {
      $("#err_range").css("display", "none");
    }
  }

  function clearNoOfAttendees() {
    document.getElementById("NoOfAttendees").value = "";
    const radios = document.getElementsByName("pcqNoofattendees");
    radios.forEach((radio) => (radio.checked = false));
    document.getElementById("err_range").style.display = "none";
  }

  function onStepperChnage(step) {
    var percent = (parseInt(step) / 3) * 100;
    $(".inq-progress-bar").css({ width: percent + "%" });
    $(".inq-progress-bar").text("Step " + step + " of 3");
  }

  function nextTab(elem) {
    $(elem).parent().next().addClass("active");
    $(elem).parent().next().find("a").addClass("active");
    $(elem).parent().next().find('a[data-toggle="tab"]').click();

    let id = "#step" + currentStep;
    $(id).removeClass("active");
    $(id).css("display", "none");

    $(id).next().addClass("active");
    $(id).next().css("display", "block");
    currentStep++;
  }

  function prevTab(elem) {
    $(elem).parent().prev().find("a").addClass("active");
    $(elem).parent().prev().find('a[data-toggle="tab"]').click();

    let id = "#step" + currentStep;
    $(id).removeClass("active");
    $(id).css("display", "none");

    $(id).prev().addClass("active");
    $(id).prev().css("display", "block");

    currentStep--;
  }

  function getImageUrl(val) {
    var base = ImageURL;
    var data = Model.Images;
    if (val && data) {
      var file = "";
      let ballroom = val.toLowerCase().trim();
      const fileData = data.find(
        (e) => e.BallRoomName.toLowerCase() === ballroom
      );
      if (fileData) {
        file = fileData.SavedName;
      }
      // file = data.find(
      //   (e) => e.BallRoomName.toLowerCase() == ballroom
      // ).SavedName;
      return base + file;
    }
    return "";
  }

  function bulidfunclist(response) {
    $(".card-functions").css("display", "");
    $("#WeddingFunctionList").css("display", "");
    $("#WeddingFunctionList").html("");
    $("#Pcq").css("display", "none");
    for (var i = 0; i < 2; i++) {
      var row = $('<div id="wedding" style="margin-bottom: 12px">').addClass(
        "row"
      );
      var col1 = $("<div>").addClass("col-md-3");
      var col2 = $("<div>").addClass("col-md-3");
      var col3 = $('<div style="text-align: center;">').addClass("col-md-6");

      WeddingfuncList.push({
        id: i,
      });

      var eventFunction = $('<div id="EventFunction">');
      var datePickerColumn = $('<div id="datepicker" >');

      var myslider = $('<div class="my-slider" style="margin-top:0px;">');
      var formwrapper = $('<div id="form-wrapper" style="margin-top:0px;">');
      var form = $("<form>");
      var debtamountslider = $('<div id="debt-amount-slider" >');
      var debtamountpos = $('<div id="debt-amount-pos">');

      var functionList = $("<input>").attr({
        class: "wedFunctionList",
        id: "WedFuncList" + i,
        "data-id": i,
        placeholder: i == 0 ? "Function Type *" : "Function Type",
      });
      eventFunction.append(functionList);
      col1.append(eventFunction);

      var datePicker = $("<input>").attr({
        type: "text",
        placeholder: i == 0 ? "Start Date *" : "Start Date",
        class: "datepicker",
        "data-id": i,
      });
      datePickerColumn.append(datePicker);
      col2.append(datePickerColumn);

      var noOfAttendeesArray = Model.NoofAttendees;

      for (var j = 0; j < noOfAttendeesArray.length; j++) {
        var radio = $("<input>", {
          type: "radio",
          name: "Noofattendees",
          id: "MulFunctionRange" + i + j,
          value: noOfAttendeesArray[j].Value,
          required: true,
          "data-id": i,
        });
        var label = $("<label>", {
          for: "MulFunctionRange" + i + j,
          "data-debt-amount": noOfAttendeesArray[j].Text,
        });
        debtamountslider.append(radio, label);
      }

      debtamountslider.append(debtamountpos);
      form.append(debtamountslider);
      formwrapper.append(form);
      myslider.append(formwrapper);
      if (i == 0) {
        var spanElement = $("<span>")
          .css({
            "font-size": "14px",
            "margin-bottom": "15px",
            color: "gray",
          })
          .text("No of attendees*");
        col3.append(spanElement);
      }
      col3.append(myslider);

      row.append(col1);
      row.append(col2);
      row.append(col3);

      row.find(".wedFunctionList").kendoAutoComplete({
        filter: "contains",
        dataTextField: "Name",
        dataSource: response,
        change: function (e) {
          isvalueschanged = true;
          var selectedFunction = this.value();
          var dataId = $(this.element).data("id");
          WeddingfuncList[dataId].Name = selectedFunction;
        },
      });

      row.find(".wedFunctionList").each(function () {
        $(this).on("focus", function () {
          var autocomplete = $(this).data("kendoAutoComplete");
          autocomplete.search();
        });
      });

      row.find(".datepicker").kendoDatePicker({
        min: new Date(today.getFullYear(), today.getMonth(), 1),
        disableDates: function (date) {
          return date < today;
        },
        change: function (e) {
          isvalueschanged = true;
          var selectedDate = this.value();
          var dataId = $(this.element).data("id");
          var formattedDate = kendo.toString(selectedDate, "MM/dd/yyyy");
          WeddingfuncList[dataId].FunctionDate = formattedDate;
        },
      });
      $(".datepicker").attr("readonly", true);

      $(".datepicker").on("keydown", function (e) {
        e.preventDefault();
      });

      row.find(".datepicker").on("focus", function () {
        var datepicker = $(this).data("kendoDatePicker");
        datepicker.open();
      });

      $("#WeddingFunctionList").append(row);
    }

    $('input[name="Noofattendees"]').change(function () {
      validateForm();
      var dataId = $(this).data("id");
      var selectedValue = $(this).val();
      var selectedText = $('label[for="' + $(this).attr("id") + '"]').data(
        "debt-amount"
      );
      WeddingfuncList[dataId].RangeId = selectedText;
      WeddingfuncList[dataId].AttendeesId = selectedValue;
    });
  }

  function saveInquiry() {
    $.ajax({
      type: "POST",
      url: `${MvcAPPURL}${"ContactUs/SaveInquiryForm"}`,
      data: JSON.stringify(inquiry),
      contentType: "application/json; charset=utf-8",
      success: function (res) {
        if (res) {
          inquiry.InquiryId = res;
        }
        fieldValueArray = {};
        $("#finish-btn").css("display", "");
        $("#loader-finish").css("display", "none");
      },
      error: function (err) {
        console.error(err);
      },
    });
  }

  function checkindex() {
    IndexhumanNumber = $("#usernumber1").val();
    IndexrandomTotal = IndexrandomNum1 + IndexrandomNum2;

    var h = 0;
    if (IndexrandomTotal == IndexhumanNumber) {
      $("#err_captcha").css("display", "none");
      $("#usernumber1").removeClass("err-field");
    } else if (
      IndexhumanNumber == "" ||
      IndexhumanNumber == null ||
      IndexhumanNumber == "undefined"
    ) {
      $("#err_captcha").css("display", "");
      $("#usernumber1").addClass("err-field");

      h = 1;
    } else {
      IndextimesWrong = IndextimesWrong + 1;
      $("#err_captcha").text("Invalid Captcha! Please try again.");
      $("#err_captcha").css("display", "");
      $("#usernumber1").addClass("err-field");
      h = 1;
      $("#usernumber1").focus().select();
      differentProblem();
    }

    if (h == 0) {
      return 0;
    } else {
      return 1;
    }
  }

  async function onValidation(e) {
    var error = 0;

    error += validateNameField("#FirstName", "#err_firstname");
    error += validateNameField("#LastName", "#err_lastname");
    error += IsEmailValid($("#Email").val());
    error += validatePhonenoField("#PhoneNo", "#err_phone");
    error += validateEvent();
    error += validateDropDown("#hear-about-us", "#err_Reference");

    if ($("#Culture_dd").is(":visible") && $("#Culture").val().trim() != "") {
      error += validateForm();
    }

    if ($("#Pcq").is(":visible")) {
      if ($("#private-party-corporate").is(":visible")) {
        error += validateField("#FunctionName", "#err_FunctionName");
      }

      error += validateField("#EventDate", "#err_FuncEventDate");

      if ($('input[name="pcqNoofattendees"]:checked').length === 0) {
        $("#err_range").css("display", "");
        error += 1;
      } else {
        $("#err_range").css("display", "none");
      }
    }
    error += checkindex();

    if (error > 0) {
      return true;
    } else {
      onStepperChnage(currentStep + 1);
      var FirstName = $("#FirstName").val();
      var LastName = $("#LastName").val();
      var Email = $("#Email").val();
      var PhoneNo = $("#PhoneNo").val();

      var EventId = $(".active-card").data("id");
      var EvenetName = $(".active-card").data("name");

      var culture = 0;
      var cultureName = "";
      if ($("#Culture_dd").is(":visible")) {
        culture = $("#Culture").val();
        cultureName = $("#Culture").data("kendoDropDownList")?.text() || "";
      }

      var FunctionId = 0;
      var FunctionName = "";
      var EventDate = "";
      var AttendeneesRangeID = "";
      var AttendeesId = 0;
      if ($("#Pcq").is(":visible")) {
        if ($("#private-party-corporate").is(":visible")) {
          FunctionId = $("#FunctionName").val();
          FunctionName =
            $("#FunctionName").data("kendoAutoComplete").value() || "";
        } else if ($("#Quince").is(":visible")) {
          FunctionName = "Quinceañera";
        } else if ($("#Wedding").is(":visible")) {
          FunctionName = "Wedding";
        }

        EventDate = $("#EventDate").val();
        AttendeneesRangeID = $('input[name="pcqNoofattendees"]:checked').val();
        AttendeesId = $('input[name="pcqNoofattendees"]:checked').data("id");
      }

      var Haveyoubeen = $("#Have-you-been").prop("checked");
      var hearaboutus = $("#hear-about-us").val();
      var funcList = [];
      if ($("#Pcq").css("display") == "none") {
        funcList = WeddingfuncList;
      }
      var Details = $("#Additional_details").val();
      var IsMultiDate = $("#mul_Date_Func").prop("checked");
      if (isvalueschanged == true) {
        if (
          ogfieldValueArray != null &&
          Object.keys(ogfieldValueArray).length > 0
        ) {
          var bothsame = compareObjects(ogfieldValueArray, fieldValueArray);
          if (bothsame) {
            isvalueschanged = true;
          } else {
            isvalueschanged = false;
          }
        }
      }

      var formData = {
        FirstName: FirstName,
        LastName: LastName,
        PhoneNo: PhoneNo,
        EmailID: Email,
        EventId: EventId,
        EventName: EvenetName,
        EventDate: EventDate,
        CultureId: culture,
        CultureName: cultureName,
        PCFunctionId: FunctionId,
        FunctionName: FunctionName,
        NoofAttendeesRange: AttendeneesRangeID,
        MaxAttendeesId: AttendeesId,
        isRecently: Haveyoubeen,
        InquiryReference: hearaboutus,
        InquiryFunctionTypeList: funcList,
        AdditionalDetails: Details,
        IsMultiDateEvent: IsMultiDate,
        IsValuesChanged: isvalueschanged,
        contactuniqueId: contactuniqueId,
        InquiryId: InquiryId,
      };

      $("#Server_Error").css("display", "none");
      $("#warning").css("display", "none");
      $("#step1").css("display", "none");

      $("#stepper-loader").css("display", "flex");
      $("#stepper-2").css("display", "none");
      $("#step2").css("display", "block");

      $.ajax({
        type: "POST",
        url: `${MvcAPPURL}${"ContactUs/RecommandationBallRooms"}`,
        data: JSON.stringify(formData),
        contentType: "application/json; charset=utf-8",
        success: function (result) {
          fieldValueArray["RecommendedBallroom"] = result.RecommendedBallroom;
          isvalueschanged = false;

          $("#Server_Error").css("display", "none");
          $("#warning").css("display", "none");
          $("#stepper-loader").css("display", "none");

          $("#stepper-2").css("display", "");
          if (result) {
            inquiry = result;
            inquiry.IsValuesChanged = false;
            contactuniqueId = result.contactuniqueId;
            InquiryId = result.InquiryId;
            if (result.IsBallroomavailable) {
              if (
                result.recommandationImageUrls.length == 1 &&
                (!result.InquiryFunctionTypeList ||
                  result.InquiryFunctionTypeList.length != 2 ||
                  result.IsSameRoomandDate)
              ) {
                $("#Unavailable").css("display", "none");
                $("#available").css("display", "");
                $("#bg-img").css(
                  "background-image",
                  `url('${getImageUrl(result.RecommendedBallroom)}')`
                );
                $("#Recommendation_Thankyou").css("display", "");
                $("#Recommendation_Thankyou").html(
                  result.Recommendation_Thankyou
                );
                $("#recd-footer").html(result.Recommendation_Footer);
                $("#idle-choice").html(
                  `Ideal choice for ${
                    result.WeddingFunctionName &&
                    result.WeddingFunctionName.length > 0
                      ? result.WeddingFunctionName.join(", ")
                      : result.FunctionName
                  } is`
                );
                $("#recd-ballroom").html(result.RecommendedBallroom);

                $("#ballroom-img")
                  .removeClass("col-md-7")
                  .addClass("col-md-12");
                $("#ballroom-img")
                  .removeClass("col-md-6")
                  .addClass("col-md-12");
                $("#ballroom-img")
                  .removeClass("col-md-8")
                  .addClass("col-md-12");
                $("#div-calendar").css("display", "none");
                $("#ballroom-img2").css("display", "none");
                showCalendly = true;
                $("#ImageLink").val(result.BallroomId[0]);
                $("#ImageLink").click(function (e) {
                  var id = $("#ImageLink").val();

                  var url = `/facilityMain/${id}`;

                  window.open(url, "_blank");
                });
              } else if (
                (!result.InquiryFunctionTypeList ||
                  result.InquiryFunctionTypeList.length != 2) &&
                result.BallroomNames.length > 1
              ) {
                $("#Unavailable").css("display", "none");
                $("#available").css("display", "");

                $("#bg-img").css(
                  "background-image",
                  `url('${getImageUrl(result.BallroomNames[0])}')`
                );
                $("#Recommendation_Thankyou").css("display", "");
                $("#Recommendation_Thankyou").html(
                  result.Recommendation_Thankyou
                );
                $("#recd-footer").html(result.Recommendation_Footer);
                $("#idle-choice").html(
                  `Ideal choice for ${result.WeddingFunctionName[0]} is`
                );
                $("#recd-ballroom").html(result.BallroomNames[0]);

                $("#ballroom-img").removeClass("col-md-8").addClass("col-md-6");
                $("#ballroom-img2").css("display", "");
                $("#bg-img2").css(
                  "background-image",
                  `url('${getImageUrl(result.BallroomNames[1])}')`
                );
                $("#recd-ballroom2").html(result.BallroomNames[1]);
                $("#idle-choice2").html(
                  `Ideal choice for ${result.WeddingFunctionName[1]} is`
                );

                $("#div-calendar").css("display", "none");

                showCalendly = true;

                $("#ImageLink").val(result.BallroomId[0]);
                $("#ImageLink").click(function (e) {
                  var id = $("#ImageLink").val();
                  var url = `/facilityMain/${id}`;

                  window.open(url, "_blank");
                });
                $("#ImageLink2").val(result.BallroomId[1]);
                $("#ImageLink2").click(function (e) {
                  var id = $("#ImageLink2").val();

                  var url = `/facilityMain/${id}`;

                  window.open(url, "_blank");
                });
              } else if (
                result.InquiryFunctionTypeList &&
                result.InquiryFunctionTypeList.length == 2 &&
                result.BallroomNames.length > 1
              ) {
                $("#Unavailable").css("display", "none");
                $("#available").css("display", "");

                $("#bg-img").css(
                  "background-image",
                  `url('${getImageUrl(result.BallroomNames[0])}')`
                );
                $("#Recommendation_Thankyou").css("display", "");
                $("#Recommendation_Thankyou").html(
                  result.Recommendation_Thankyou
                );
                $("#recd-footer").html(result.Recommendation_Footer);
                $("#idle-choice").html(
                  `Ideal choice for ${result.WeddingFunctionName[0]} is`
                );
                $("#recd-ballroom").html(result.BallroomNames[0]);

                $("#ballroom-img").removeClass("col-md-8").addClass("col-md-6");
                $("#ballroom-img2").css("display", "");
                $("#bg-img2").css(
                  "background-image",
                  `url('${getImageUrl(result.BallroomNames[1])}')`
                );
                $("#recd-ballroom2").html(result.BallroomNames[1]);
                $("#idle-choice2").html(
                  `Ideal choice for ${result.WeddingFunctionName[1]} is`
                );

                $("#div-calendar").css("display", "none");

                showCalendly = true;

                $("#ImageLink").val(result.BallroomId[0]);
                $("#ImageLink").click(function (e) {
                  var id = $("#ImageLink").val();
                  var url = `/facilityMain/${id}`;

                  window.open(url, "_blank");
                });
                $("#ImageLink2").val(result.BallroomId[1]);
                $("#ImageLink2").click(function (e) {
                  var id = $("#ImageLink2").val();

                  var url = `/facilityMain/${id}`;

                  window.open(url, "_blank");
                });
              } else {
                $("#available").css("display", "none");
                $("#Unavailable").css("display", "");
                $("#Recommendation_Thankyou").css("display", "");
                $("#Recommendation_Thankyou").html(
                  result.Recommendation_OtherDates
                );
                $("#recd-footer").html(result.Recommendation_Footer);

                var falseIndices = [];

                result.InquiryFunctionTypeList.forEach(function (item, index) {
                  if (item.Isavailable == false) {
                    falseIndices.push(index);
                  }
                });

                var TrueIndices = [];

                result.InquiryFunctionTypeList.forEach(function (item, index) {
                  if (item.Isavailable == true) {
                    TrueIndices.push(index);
                  }
                });
                if (falseIndices.length > 0) {
                  $("#Unavailable_bg-img").css(
                    "background-image",
                    `url('${getImageUrl(
                      result.InquiryFunctionTypeList[TrueIndices]
                        .firstPriorityBallroomName
                    )}')`
                  );
                  $("#Unavailable_idle-choice").html(
                    `Ideal choice for ${result.InquiryFunctionTypeList[TrueIndices].Name} is`
                  );
                  $("#Unavailable_recd-ballroom").html(
                    result.InquiryFunctionTypeList[TrueIndices]
                      .firstPriorityBallroomName
                  );
                  $("#Unavailable_ballroom-img")
                    .removeClass("col-md-8")
                    .addClass("col-md-12");

                  $("#Unavailable_div-calendar").css("display", "none");
                  $("#Unavailable_Row").css("display", "");

                  $("#Unavailable_bg-img2").css(
                    "background-image",
                    `url('${getImageUrl(
                      result.InquiryFunctionTypeList[falseIndices]
                        .firstPriorityBallroomName
                    )}')`
                  );
                  $("#Unavailable_idle-choice2").html(
                    `Ideal choice for ${result.InquiryFunctionTypeList[falseIndices].Name} is`
                  );
                  $("#Unavailable_recd-ballroom2").html(
                    result.InquiryFunctionTypeList[falseIndices]
                      .firstPriorityBallroomName
                  );

                  var startDateParts =
                    result.InquiryFunctionTypeList[
                      falseIndices
                    ].FunctionDate.split("/");
                  var startDate = new Date(
                    parseInt(startDateParts[2], 10),
                    parseInt(startDateParts[0], 10) - 1,
                    parseInt(startDateParts[1], 10)
                  );
                  now3 = startDate;
                  Unavailable_loadCalendar2(
                    result.InquiryFunctionTypeList[falseIndices]
                      .firstPriorityavailableDates || [],
                    startDate,
                    falseIndices
                  );
                  $("#Unavailable_div-calendar2").css("display", "");

                  $("#Unavailable_ImageLink").val(
                    result.InquiryFunctionTypeList[TrueIndices].BallRoomId
                  );
                  $("#Unavailable_ImageLink").click(function (e) {
                    var id = $("#Unavailable_ImageLink").val();
                    var url = `/facilityMain/${id}`;

                    window.open(url, "_blank");
                  });
                  $("#Unavailable_ImageLink2").val(
                    result.InquiryFunctionTypeList[falseIndices].BallRoomId
                  );
                  $("#Unavailable_ImageLink2").click(function (e) {
                    var id = $("#Unavailable_ImageLink2").val();

                    var url = `/facilityMain/${id}`;

                    window.open(url, "_blank");
                  });

                  showCalendly = false;
                }
              }

              $("#warning").css("display", "none");
              $("#Server_Error").css("display", "none");
              $("#warning").css("height", "0px");
              $("#Server_Error").css("height", "0px");
            } else {
              var s =
                result.InquiryFunctionTypeList &&
                result.InquiryFunctionTypeList.find((x) => x.IsBallRoomMapped);

              if (
                result.InquiryFunctionTypeList &&
                result.InquiryFunctionTypeList.length > 0 &&
                s != null
              ) {
                $("#available").css("display", "none");
                $("#Unavailable").css("display", "");
                $("#Recommendation_Thankyou").css("display", "");
                $("#Recommendation_Thankyou").html(
                  result.Recommendation_OtherDates
                );
                $("#recd-footer").html(result.Recommendation_Footer);
                $("#ballroom-img")
                  .removeClass("col-md-12")
                  .addClass("col-md-8");

                var falseIndices = [];

                result.InquiryFunctionTypeList.forEach(function (item, index) {
                  if (item.Isavailable == false) {
                    falseIndices.push(index);
                  }
                });

                var TrueIndices = [];

                result.InquiryFunctionTypeList.forEach(function (item, index) {
                  if (item.Isavailable == true) {
                    TrueIndices.push(index);
                  }
                });
                if (result.InquiryFunctionTypeList.length == 1) {
                  $("#Unavailable_bg-img").css(
                    "background-image",
                    `url('${getImageUrl(
                      result.InquiryFunctionTypeList[0]
                        .firstPriorityBallroomName
                    )}')`
                  );
                  $("#Unavailable_idle-choice").html(
                    `Ideal choice for ${result.InquiryFunctionTypeList[0].Name} is`
                  );
                  $("#Unavailable_recd-ballroom").html(
                    result.InquiryFunctionTypeList[0].firstPriorityBallroomName
                  );
                  var startDateParts =
                    result.InquiryFunctionTypeList[0].FunctionDate.split("/");
                  var startDate = new Date(
                    parseInt(startDateParts[2], 10),
                    parseInt(startDateParts[0], 10) - 1,
                    parseInt(startDateParts[1], 10)
                  );
                  now2 = startDate;
                  Unavailable_loadCalendar(
                    result.InquiryFunctionTypeList[0]
                      .firstPriorityavailableDates || [],
                    startDate,
                    0
                  );
                  $("#Unavailable_div-calendar").css("display", "");
                  $("#Unavailable_div-calendar2").css("display", "none");
                  $("#Unavailable_bg-img2").css("display", "none");
                  $("#Unavailable_Row").css("display", "none");
                } else if (falseIndices.length > 1) {
                  $("#Unavailable_bg-img").css(
                    "background-image",
                    `url('${getImageUrl(
                      result.InquiryFunctionTypeList[0]
                        .firstPriorityBallroomName
                    )}')`
                  );
                  $("#Unavailable_idle-choice").html(
                    `Ideal choice for ${result.InquiryFunctionTypeList[0].Name} is`
                  );
                  $("#Unavailable_recd-ballroom").html(
                    result.InquiryFunctionTypeList[0].firstPriorityBallroomName
                  );
                  $("#Unavailable_ballroom-img")
                    .removeClass("col-md-12")
                    .addClass("col-md-8");
                  var startDateParts =
                    result.InquiryFunctionTypeList[0].FunctionDate.split("/");
                  var startDate = new Date(
                    parseInt(startDateParts[2], 10),
                    parseInt(startDateParts[0], 10) - 1,
                    parseInt(startDateParts[1], 10)
                  );
                  now2 = startDate;
                  Unavailable_loadCalendar(
                    result.InquiryFunctionTypeList[0]
                      .firstPriorityavailableDates || [],
                    startDate,
                    0
                  );
                  $("#Unavailable_div-calendar").css("display", "");
                  $("#Unavailable_Row").css("display", "");
                  $("#Unavailable_bg-img2").css("display", "");

                  $("#Unavailable_bg-img2").css(
                    "background-image",
                    `url('${getImageUrl(
                      result.InquiryFunctionTypeList[1]
                        .firstPriorityBallroomName
                    )}')`
                  );
                  $("#Unavailable_idle-choice2").html(
                    `Ideal choice for ${result.InquiryFunctionTypeList[1].Name} is`
                  );
                  $("#Unavailable_recd-ballroom2").html(
                    result.InquiryFunctionTypeList[1].firstPriorityBallroomName
                  );

                  var startDateParts =
                    result.InquiryFunctionTypeList[1].FunctionDate.split("/");
                  var startDate = new Date(
                    parseInt(startDateParts[2], 10),
                    parseInt(startDateParts[0], 10) - 1,
                    parseInt(startDateParts[1], 10)
                  );
                  now3 = startDate;
                  Unavailable_loadCalendar2(
                    result.InquiryFunctionTypeList[1]
                      .firstPriorityavailableDates || [],
                    startDate,
                    1
                  );
                  $("#Unavailable_div-calendar2").css("display", "");

                  $("#Unavailable_ImageLink").val(
                    result.InquiryFunctionTypeList[0].BallRoomId
                  );
                  $("#Unavailable_ImageLink").click(function (e) {
                    var id = $("#Unavailable_ImageLink").val();
                    var url = `/facilityMain/${id}`;

                    window.open(url, "_blank");
                  });
                  $("#Unavailable_ImageLink2").val(
                    result.InquiryFunctionTypeList[1].BallRoomId
                  );
                  $("#Unavailable_ImageLink2").click(function (e) {
                    var id = $("#Unavailable_ImageLink2").val();

                    var url = `/facilityMain/${id}`;

                    window.open(url, "_blank");
                  });

                  showCalendly = true;
                } else {
                  $("#Unavailable_bg-img").css(
                    "background-image",
                    `url('${getImageUrl(
                      result.InquiryFunctionTypeList[TrueIndices]
                        .firstPriorityBallroomName
                    )}')`
                  );
                  $("#Unavailable_idle-choice").html(
                    `Ideal choice for ${result.InquiryFunctionTypeList[TrueIndices].Name} is`
                  );
                  $("#Unavailable_recd-ballroom").html(
                    result.InquiryFunctionTypeList[TrueIndices]
                      .firstPriorityBallroomName
                  );
                  $("#Unavailable_ballroom-img")
                    .removeClass("col-md-8")
                    .addClass("col-md-12");

                  $("#Unavailable_div-calendar").css("display", "none");

                  $("#Unavailable_bg-img2").css(
                    "background-image",
                    `url('${getImageUrl(
                      result.InquiryFunctionTypeList[falseIndices]
                        .firstPriorityBallroomName
                    )}')`
                  );
                  $("#Unavailable_idle-choice2").html(
                    `Ideal choice for ${result.InquiryFunctionTypeList[falseIndices].Name} is`
                  );
                  $("#Unavailable_recd-ballroom2").html(
                    result.InquiryFunctionTypeList[falseIndices]
                      .firstPriorityBallroomName
                  );

                  var startDateParts =
                    result.InquiryFunctionTypeList[
                      falseIndices
                    ].FunctionDate.split("/");
                  var startDate = new Date(
                    parseInt(startDateParts[2], 10),
                    parseInt(startDateParts[0], 10) - 1,
                    parseInt(startDateParts[1], 10)
                  );
                  now3 = startDate;
                  Unavailable_loadCalendar2(
                    result.InquiryFunctionTypeList[falseIndices]
                      .firstPriorityavailableDates || [],
                    startDate,
                    falseIndices
                  );
                  $("#Unavailable_div-calendar2").css("display", "");
                  $("#Unavailable_Row").css("display", "");

                  $("#Unavailable_ImageLink").val(
                    result.InquiryFunctionTypeList[TrueIndices].BallRoomId
                  );
                  $("#Unavailable_ImageLink").click(function (e) {
                    var id = $("#Unavailable_ImageLink").val();
                    var url = "/CFacilities?iID=__iIDValue__";

                    url = url.replace("__iIDValue__", id);

                    window.open(url, "_blank");
                  });
                  $("#Unavailable_ImageLink2").val(
                    result.InquiryFunctionTypeList[falseIndices].BallRoomId
                  );
                  $("#Unavailable_ImageLink2").click(function (e) {
                    var id = $("#Unavailable_ImageLink2").val();

                    var url = "/CFacilities?iID=__iIDValue__";

                    url = url.replace("__iIDValue__", id);

                    window.open(url, "_blank");
                  });

                  showCalendly = false;
                }
                $("#warning").css("display", "none");
                $("#Server_Error").css("display", "none");
                $("#warning").css("height", "0px");
                $("#Server_Error").css("height", "0px");
              } else if (
                (result.RecommendedBallroom != null &&
                  result.RecommendedBallroom != "") ||
                (result.BallRoomsAvailableDate != null &&
                  result.BallRoomsAvailableDate.length > 0)
              ) {
                $("#Unavailable").css("display", "none");
                $("#available").css("display", "");
                $("#ballroom-img2").css("display", "none");
                $("#bg-img").css(
                  "background-image",
                  `url('${getImageUrl(result.RecommendedBallroom)}')`
                );
                $("#Recommendation_Thankyou").css("display", "");
                $("#Recommendation_Thankyou").html(
                  result.Recommendation_OtherDates
                );
                $("#recd-footer").html(result.Recommendation_Footer);

                $("#idle-choice").html(
                  `Ideal choice for ${result.FunctionName} is`
                );
                $("#recd-ballroom").html(result.RecommendedBallroom);

                $("#ballroom-img")
                  .removeClass("col-md-12")
                  .addClass("col-md-8");
                $("#ballroom-img").removeClass("col-md-6").addClass("col-md-8");

                var startDateParts = result.StartDate.split("/");
                var startDate = new Date(
                  parseInt(startDateParts[2], 10),
                  parseInt(startDateParts[0], 10) - 1,
                  parseInt(startDateParts[1], 10)
                );
                now = startDate;
                loadCalendar(result.BallRoomsAvailableDate || [], startDate);
                $("#div-calendar").css("display", "");

                $("#ImageLink").val(result.BallroomId[0]);
                $("#ImageLink").click(function (e) {
                  var id = $("#ImageLink").val();
                  var url = `/facilityMain/${id}`;

                  window.open(url, "_blank");
                });

                $("#warning").css("display", "none");
                $("#Server_Error").css("display", "none");
                $("#warning").css("height", "0px");
                $("#Server_Error").css("height", "0px");

                showCalendly = false;
              } else {
                if (!result.BallRoomsAvailableDate && result.IsBallRoomMapped) {
                  $("#Unavailable").css("display", "none");
                  $("#warning").css("display", "none");
                  $("#warning").css("height", "0px");
                  $("#Server_Error").css("height", "400px");
                  $("#Server_Error").css("display", "");
                  $("#stepper-2").css("display", "none");
                } else {
                  $("#Unavailable").css("display", "none");
                  $("#Server_Error").css("display", "none");
                  $("#warning").css("height", "0px");
                  $("#warning").css("display", "");
                  $("#warning").css("height", "400px");
                  $("#stepper-2").css("display", "none");
                }

                showCalendly = false;
              }
            }
          } else {
            $("#warning").css("display", "");
            $("#stepper-2").css("display", "none");
            showCalendly = false;
          }

          Issuccess = true;
        },
        error: function (error) {
          console.error(error);
        },
      });

      return false;
    }
  }

  function IsEmailValid(email) {
    if (email.trim() === "") {
      $("#err_email").html("<i>Email is required</i>");
      $("#err_email").css("display", "");
      $("#Email").addClass("err-field");
      return 1;
    } else {
      var expr =
        /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      if (expr.test(email)) {
        $("#err_email").css("display", "none");
        $("#Email").removeClass("err-field");
        return 0;
      } else {
        $("#err_email").css("display", "");
        $("#err_email").html("<i>Please enter valid email</i>");
        $("#Email").addClass("err-field");
        return 1;
      }
    }
  }

  function validatePhonenoField(id, errId) {
    var phone = $("#PhoneNo").val();
    if (phone.length != 14) {
      $("#PhoneNo").addClass("err-field");
      $("#PhoneNo").focus().select();
      $("#err_phone").html("<i>Please enter valid phone number</i>").show();
      return 1;
    } else {
      $("#err_phone").css("display", "none");
      $("#PhoneNo").removeClass("err-field");
      return 0;
    }
  }

  function validateForm() {
    var selectedRows = 0;

    for (var i = 0; i < WeddingfuncList.length; i++) {
      var datepickerValue = kendo.toString(
        $('#wedding .datepicker[data-id="' + i + '"]')
          .data("kendoDatePicker")
          .value(),
        "MM/dd/yyyy"
      );
      var radioValue = $(
        '#wedding input[name="Noofattendees"]:checked[data-id="' + i + '"]'
      ).val();

      if (datepickerValue && radioValue) {
        selectedRows++;
      }
    }

    if (selectedRows >= 1) {
      $("#err_date_range").css("display", "none");
      return 0;
    } else {
      $("#err_date_range").css("display", "");
      return 1;
    }
  }

  function validateField(id, errId) {
    if ($(id).val().trim() == "") {
      $(errId).css("display", "");
      $(id).addClass("err-field");
      return 1;
    } else {
      $(errId).css("display", "none");
      $(id).removeClass("err-field");
      return 0;
    }
  }

  function validateEvent() {
    var selectedCard = $("#card-events .my-card.active-card");

    if (selectedCard.length === 0) {
      $("#err_event").css("display", "");
      return 1;
    } else {
      $("#err_event").css("display", "none");
      return 0;
    }
  }

  function validateDropDown(id, errId) {
    var dropdown = $(id).data("kendoDropDownList");

    if (!dropdown || !dropdown.value()) {
      $(errId).css("display", "");
      $(id).parent().addClass("err-field");
      return 1;
    } else {
      $(errId).css("display", "none");
      $(id).parent().removeClass("err-field");
      return 0;
    }
  }

  function validateNameField(id, errId) {
    var name = $(id).val();

    var isValid = /^[A-Za-z]+$/.test(name.replace(/\s/g, ""));
    if (isValid && $(id).val().trim() != "") {
      $(errId).css("display", "none");
      $(id).removeClass("err-field");
      return 0;
    } else if (id == "#FirstName") {
      $(errId).css("display", "");
      $(errId).html("Please enter valid first name");
      $(id).addClass("err-field");
      return 1;
    } else {
      $(errId).css("display", "");
      $(errId).html("Please enter valid last name");
      $(id).addClass("err-field");
      return 1;
    }
  }

  function sendSMS() {
    if (inquiry && inquiry.InquiryId) {
      $.ajax({
        type: "GET",
        url: `${MvcAPPURL}${"ContactUs/SendSMS"}`,
        data: { InquiryId: inquiry.InquiryId },
        success: function (res) {},
      });
    }
  }

  var floatinglabel = function () {
    jQuery(".floating-label .form-control").each(function (index, el) {
      var text_val = jQuery(this).val();
      if (text_val === "") {
        jQuery(this).parent().removeClass("has-value");
      } else {
        jQuery(this).parent().addClass("has-value");
      }
      jQuery(this)
        .focus(function () {
          jQuery(this).parent().addClass("has-value");
        })
        .blur(function () {
          if (
            jQuery(this).val() === "" ||
            jQuery(this).val() === " " ||
            jQuery(this).val() === null
          ) {
            jQuery(this).parent().removeClass("has-value");
          }
        });
    });
  };

  $(".card-functions .form-control")
    .on("focus blur change", function (e) {
      var $currEl = $(this);

      if ($currEl.is("select")) {
        if ($currEl.val() === $("option:first", $currEl).val()) {
          $(".control-label", $currEl.parent()).animate({ opacity: 0 }, 240);
          $currEl.parent().removeClass("focused");
        } else {
          $(".control-label", $currEl.parent()).css({ opacity: 1 });
          $currEl
            .parents(".form-group")
            .toggleClass(
              "focused",
              (e.type === "focus" || this.value.length > 0) &&
                $currEl.val() !== $("option:first", $currEl).val()
            );
        }
      } else {
        $currEl
          .parents(".form-group")
          .toggleClass("focused", e.type === "focus" || this.value.length > 0);
      }
    })
    .trigger("blur");

  function UnconditionalSave() {
    if (
      $("#Pcq").css("display") == "none" &&
      $("#WeddingFunctionList").css("display") != "none"
    ) {
      fieldValueArray["InquiryFunctionTypeList"] = WeddingfuncList;
    }

    var formData = {
      FirstName: fieldValueArray.FirstName,
      LastName: fieldValueArray.LastName,
      PhoneNo: fieldValueArray.PhoneNo,
      EmailID: fieldValueArray.Email,
      EventId: fieldValueArray.EventId,
      EventName: fieldValueArray.EventName,
      EventDate: fieldValueArray.EventDate,
      StartDate: fieldValueArray.StartDate,
      CultureId: fieldValueArray.CultureId,
      CultureName: fieldValueArray.CultureName,
      PCFunctionId: fieldValueArray.PCFunctionId,
      FunctionName: fieldValueArray.FunctionName,
      NoofAttendeesRange: fieldValueArray.NoofAttendeesRange,
      MaxAttendeesId: fieldValueArray.MaxAttendeesId,
      isRecently: fieldValueArray.isRecently,
      InquiryReference: fieldValueArray.InquiryReference,
      InquiryFunctionTypeList: fieldValueArray.InquiryFunctionTypeList,
      AdditionalDetails: fieldValueArray.AdditionalDetails,
      IsMultiDateEvent: fieldValueArray.IsMultiDateEvent,
      RecommendedBallroom: fieldValueArray.RecommendedBallroom,
      IsValuesChanged: isvalueschanged,
    };
    $.ajax({
      type: "POST",
      url: `${MvcAPPURL}${"ContactUs/SaveTempInquiryForm"}`,
      data: JSON.stringify(formData),
      contentType: "application/json; charset=utf-8",
      success: function (result) {
        //    fieldValueArray = {};
        isvalueschanged = false;
      },
      error: function (error) {
        isvalueschanged = false;
        console.error(error);
      },
    });
  }

  window.onbeforeunload = function () {
    var Email = $("#Email").val();
    var PhoneNo = $("#PhoneNo").val();
    if ((Email || PhoneNo) && isvalueschanged) {
      if (fieldValueArray) {
        UnconditionalSave();
      }
    }
    // reconnect = true;
  };

  function compareObjects(obj1, obj2) {
    // Check if both arguments are objects
    if (obj1 != null && obj2 != null) {
      if (typeof obj1 == "object" && typeof obj2 == "object") {
        // Get the keys of both objects
        const keys1 = Object.keys(obj1);
        const keys2 = Object.keys(obj2);
        // If the number of keys is different, objects are different
        if (keys1.length !== keys2.length) {
          return true;
        }

        // Check each key-value pair recursively
        for (let key of keys1) {
          if (!compareObjects(obj1[key], obj2[key])) {
            return false;
          } else {
            return true;
          }
        }
        // If all key-value pairs are the same
        return true;
      } else {
        // If not objects, compare values directly
        return obj1 === obj2;
      }
    }
  }

  useEffect(() => {
    if (Model != null && Object.keys(Model).length > 0) {
      differentProblem();

      $(".date-picker")
        .kendoDatePicker({
          min: new Date(today.getFullYear(), today.getMonth(), 1),
          format: "MM/dd/yyyy",
          change: function (e) {
            isvalueschanged = true;
            validateField("#EventDate", "#err_FuncEventDate");
            fieldValueArray["EventDate"] = this.value();
          },
          disableDates: function (date) {
            return date < today;
          },
        })
        .data("kendoDatePicker")
        .setOptions({
          fillMode: "flat",
        });
      $(".date-picker").attr("readonly", true);

      $(".date-picker").on("keydown", function (e) {
        e.preventDefault();
      });
      $("#FunctionName").kendoAutoComplete({
        filter: "contains",
        placeholder: "Function Type *",
        dataTextField: "Name",
        change: function (e) {
          isvalueschanged = true;
          fieldValueArray["FunctionName"] = this.value();
        },
      });

      $("#hear-about-us")
        .kendoDropDownList({
          dataTextField: "Text",
          dataValueField: "Value",
          dataSource: {
            data: Model.ddlInquiryReferencelist,
          },
          change: function (e) {},
        })
        .data("kendoDropDownList")
        .setOptions({
          fillMode: "flat",
        });

      $("#Culture")
        .kendoDropDownList({
          popup: {
            appendTo: $("#inquiry-div"),
          },
          optionLabel: "Choose Your Culture",
          filter: "contains",
          dataTextField: "CultureName",
          dataValueField: "CultureId",
          dataSource: {
            data: Model.CultureList,
          },

          change: function (e) {
            $("#err_date_range").css("display", "none");
            isvalueschanged = true;
            var CultureId = this.value();
            fieldValueArray["CultureId"] = CultureId;
            fieldValueArray["CultureName"] =
              $("#Culture").data("kendoDropDownList")?.text() || "";
            if (CultureId) {
              $.ajax({
                url: `${MvcAPPURL}${"ContactUs/GetCultureFunctionList"}`,
                type: "Get",
                data: { CultureId: CultureId },
                success: function (response) {
                  WeddingfuncList = [];
                  bulidfunclist(response);
                },
                error: function (error) {
                  console.error("Error:", error);
                },
              });
            } else {
              $("#WeddingFunctionList").html("");
              $("#WeddingFunctionList").css("display", "none");
              $("#Culture_dd").css("display", "");
              $(".card-functions").css("display", "");
              $("#private-party-corporate").css("display", "none");
              $("#Pcq").css("display", "");
              $("#Quince").css("display", "none");
              $("#Wedding").css("display", "");
            }
          },
        })
        .data("kendoDropDownList")
        .setOptions({
          fillMode: "flat",
        });

      $("#loader-medium")
        .kendoLoader({
          size: "medium",
        })
        .data("kendoLoader")
        .setOptions({
          type: "converging-spinner",
        });

      $("#loader-finish")
        .kendoLoader({
          size: "medium",
        })
        .data("kendoLoader")
        .setOptions({
          type: "pulsing",
        });

      $("#EventDate").on("focus", function () {
        var datepicker = $("#EventDate").data("kendoDatePicker");
        datepicker.open();
      });

      $(".nav-tabs > li a[title]").tooltip();

      $(".next-step").click(async function (e) {
        var err = false;
        if (currentStep == 1) {
          err = await onValidation();
        } else if (currentStep == 2) {
          if (!showCalendly) {
            err = true;
          } else {
            onStepperChnage(currentStep + 1);
            saveInquiry();
          }
        } else if (currentStep == 3) {
          oncloseModal();
        }

        if (!err) {
          var $active = $("#inquiry-div .wizard .nav-tabs li a.active");
          $active.removeClass("active");
          $active.parent().next().children().removeClass("disabled");
          $active.parent().addClass("done");
          nextTab($active);
        }
      });

      $(".prev-step").click(function (e) {
        var $active = $("#inquiry-div .wizard .nav-tabs li a.active");
        $active.removeClass("active").addClass("disabled");
        $active.parent().removeClass("done");
        onStepperChnage(currentStep - 1);
        prevTab($active);
        now = new Date();
        now2 = new Date();
        now3 = new Date();
        isvalueschanged = false;

        ogfieldValueArray = structuredClone(fieldValueArray);
        differentProblem();
      });

      $(".my-card").on({
        click: function () {
          isvalueschanged = true;
          //clear validations
          $("#err_FunctionName").css("display", "none");
          $("#err_FuncEventDate").css("display", "none");
          $("#err_range").css("display", "none");

          $("#card-events .active-card").removeClass("active-card");
          $(this).toggleClass("active-card");
          $(this)
            .parent(".col")
            .siblings()
            .children(".card")
            .removeClass("active-card");

          var selectedCard = $("#card-events .my-card.active-card");
          var dataId = selectedCard.data("id");
          fieldValueArray["EventId"] = $(".active-card").data("id");
          fieldValueArray["EventName"] = $(".active-card").data("name");
          if (selectedCard.length == 0) {
            $("#err_event").css("display", "");
          } else {
            $("#err_event").css("display", "none");
            if (dataId == 4) {
              clearNoOfAttendees();
              fieldValueArray["FunctionName"] = "Wedding";
              $("#WeddingFunctionList").html("");
              $("#WeddingFunctionList").css("display", "none");
              $("#Culture").data("kendoDropDownList").value("");
              $("#Culture_dd").css("display", "");
              $(".card-functions").css("display", "");
              $("#private-party-corporate").css("display", "none");
              document.getElementById("FunctionName").value = "";
              $("#Pcq").css("display", "");
              $("#Quince").css("display", "none");
              $("#Wedding").css("display", "");
            } else if (dataId == 3) {
              clearNoOfAttendees();
              fieldValueArray["FunctionName"] = "Quincenera";
              $("#WeddingFunctionList").html("");
              $("#WeddingFunctionList").css("display", "none");
              $("#Culture_dd").css("display", "none");
              $(".card-functions").css("display", "");
              $("#private-party-corporate").css("display", "none");
              document.getElementById("FunctionName").value = "";
              $("#Pcq").css("display", "");
              $("#Quince").css("display", "");
              $("#Wedding").css("display", "none");
              $("#Culture").data("kendoDropDownList").value("");
            } else {
              clearNoOfAttendees();
              $("#WeddingFunctionList").html("");
              $("#WeddingFunctionList").css("display", "none");
              $("#Quince").css("display", "none");
              $("#Culture_dd").css("display", "none");
              $(".card-functions").css("display", "");
              $("#Pcq").css("display", "");
              $("#private-party-corporate").css("display", "");
              document.getElementById("FunctionName").value = "";
              $("#Culture").data("kendoDropDownList").value("");
              $("#Wedding").css("display", "none");
              var data = new kendo.data.DataSource({
                transport: {
                  read: {
                    url: `${MvcAPPURL}${"ContactUs/GetFunctionList"}?EventId=${dataId}`,
                  },
                },
              });

              var autocomplete = $("#FunctionName").data("kendoAutoComplete");
              autocomplete.setDataSource(data);
              $("#FunctionName").on("focus", function () {
                autocomplete.search();
              });
            }
            $("#EventDate").data("kendoDatePicker").value(null);
          }
        },
      });

      $("#FirstName").on("input", function () {
        var name = $(this).val();
        var isValid = /^[A-Za-z]+$/.test(name.replace(/\s/g, ""));
        if (isValid) {
          $("#err_firstname").css("display", "none");
          $("#FirstName").removeClass("err-field");
        } else {
          $("#err_firstname").css("display", "");
          $("#err_firstname").html("Please enter valid first name");
          $("#FirstName").addClass("err-field");
        }
      });

      $("#LastName").on("input", function () {
        var name = $(this).val();
        var isValid = /^[A-Za-z]+$/.test(name.replace(/\s/g, ""));
        if (isValid) {
          $("#err_lastname").css("display", "none");
          $("#LastName").removeClass("err-field");
        } else {
          $("#err_lastname").css("display", "");
          $("#err_lastname").html("Please enter valid last name");
          $("#LastName").addClass("err-field");
        }
      });

      $("#PhoneNo").on("input", function () {
        var phoneNumber = $(this).val().replace(/\D/g, "");
        var phoneRegex = /^(\d{3})(\d{3})(\d{4})$/;

        if (
          /^\d+$/.test(phoneNumber) &&
          phoneNumber.length === 10 &&
          phoneRegex.test(phoneNumber)
        ) {
          var formattedNumber = phoneNumber.replace(phoneRegex, "($1) $2-$3");
          $(this).val(formattedNumber);
          $("#validationResult").text("Valid phone number");
        } else {
          $("#validationResult").text("Invalid phone number");
        }
      });

      //Validation
      $("#FirstName").on("change", function () {
        var nameValue = $(this).val();
        fieldValueArray["FirstName"] = nameValue;
        isvalueschanged = true;

        validateNameField("#FirstName", "#err_firstname");
      });

      $("#LastName").on("change", function () {
        var nameValue = $(this).val();
        fieldValueArray["LastName"] = nameValue;
        isvalueschanged = true;

        validateNameField("#LastName", "#err_lastname");
      });

      $("#Email").on("change", function () {
        var emailValue = $(this).val();
        fieldValueArray["Email"] = emailValue;
        isvalueschanged = true;

        IsEmailValid($(this).val());
      });

      $("#PhoneNo").on("change", function () {
        var phoneNoValue = $(this).val();
        fieldValueArray["PhoneNo"] = phoneNoValue;
        isvalueschanged = true;

        validatePhonenoField("#PhoneNo", "#err_phone");
      });

      $("#card-events").on("change", function () {
        var selectedCard = $("#card-events .my-card.active-card");

        if (selectedCard.length == 0) {
          $(errId).css("display", "");
        } else {
          $(errId).css("display", "none");
          $("#Culture_dd").css("display", "");
        }
      });

      $("#hear-about-us").on("change", function () {
        fieldValueArray["InquiryReference"] = $("#hear-about-us").val();
        validateDropDown("#hear-about-us", "#err_Reference");
      });

      $("#private-party-corporate").on("change", function () {
        validateField("#FunctionName", "#err_FunctionName");
      });

      $('input[name="debt-amount"]').change(function () {
        if ($('input[name="debt-amount"]:checked').length > 0) {
          $("#err_range").css("display", "none");
        } else {
          $("#err_range").css("display", "");
        }
      });

      $("#Additional_details").on("change", function () {
        var Additional_details = $(this).val();
        fieldValueArray["AdditionalDetails"] = Additional_details;
      });

      floatinglabel();

      window.addEventListener("blur", function (event) {
        if (isvalueschanged) {
          var Email = $("#Email").val();
          var PhoneNo = $("#PhoneNo").val();
          if (Email || PhoneNo) {
            var timeInMilliseconds = Model.TimeOut;
            timeoutId = setTimeout(() => {
              if (Object.values(fieldValueArray).length > 0) {
                UnconditionalSave();
              }
            }, timeInMilliseconds);
          }
        }
      });

      window.addEventListener("focus", function (event) {
        if (timeoutId !== 0) {
          clearTimeout(timeoutId);
          timeoutId = 0;
        }
      });
    }
  }, [Model]);

  const handleChange = (event) => {
    const inputValue = event.target.value;
    if (inputValue == "" || inputValue == null || inputValue == "undefined") {
      $("#err_captcha").css("display", "");
      $("#usernumber1").addClass("err-field");
    } else {
      $("#err_captcha").css("display", "none");
      $("#usernumber1").removeClass("err-field");
    }
  };

  return (
    <>
      <div className="modal-header d-flex justify-content-between align-items-center">
        <h5
          className="modal-title mx-auto"
          style={{ textAlign: "center", flex: "1" }}
        >
          Inquiry Form
        </h5>
        <div
          style={{
            position: "absolute",
            right: "10px",
            marginBottom: "70px",
          }}
        >
          <a href="#" onClick={oncloseModal} title="Close">
            <i
              className="k-icon k-i-close"
              style={{ color: "gray", cursor: "pointer" }}
            />
          </a>
        </div>
      </div>

      <div className="modal-body">
        <div className="container" id="inquiry-div">
          <div className="page-ath-wrap">
            <div className="page-ath-content register-form-content">
              <div className="page-ath-form">
                <div className="form-align-box">
                  <div className="wizard">
                    <div className="inq-progress" style={{ height: "30px" }}>
                      <div
                        className="inq-progress-bar inq-progress-bar-striped inq-progress-bar-animated"
                        role="progressbar"
                        aria-valuenow={1}
                        aria-valuemin={1}
                        aria-valuemax={3}
                        style={{ width: "25%", paddingTop: 4 }}
                      >
                        Step 1 of 3
                      </div>
                    </div>
                    <div
                      role="form"
                      action="index.html"
                      className="register-wizard-box"
                    >
                      <div className="tab-content" id="main_form">
                        <div
                          className="tab-pane active"
                          role="tabpanel"
                          id="step1"
                        >
                          <div
                            className="form-input-steps"
                            style={{ marginTop: 40 }}
                          >
                            <div className="row" style={{ marginBottom: 16 }}>
                              <div className="col-md-3">
                                <div className="form-group floating-label">
                                  <input
                                    type="text"
                                    className="form-control"
                                    placeholder="First Name *"
                                    id="FirstName"
                                  />
                                  <span className="highlight" />
                                  <span className="bar" />
                                  <span
                                    className="k-form-error k-invalid-msg"
                                    style={{ display: "none" }}
                                    id="err_firstname"
                                  >
                                    <i>First Name is required</i>
                                  </span>
                                </div>
                              </div>
                              <div className="col-md-3">
                                <div className="form-group floating-label">
                                  <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Last Name *"
                                    id="LastName"
                                  />
                                  <span className="highlight" />
                                  <span className="bar" />
                                  <span
                                    className="k-form-error k-invalid-msg"
                                    style={{ display: "none" }}
                                    id="err_lastname"
                                  >
                                    <i>Last Name is required</i>
                                  </span>
                                </div>
                              </div>
                              <div className="col-md-3">
                                <div className="form-group floating-label">
                                  <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Email *"
                                    id="Email"
                                    title=""
                                    onInput={(e) => {
                                      e.target.setAttribute(
                                        "title",
                                        e.target.value
                                      );
                                    }}
                                  />
                                  <span className="highlight" />
                                  <span className="bar" />
                                  <span
                                    className="k-form-error k-invalid-msg"
                                    style={{ display: "none" }}
                                    id="err_email"
                                  >
                                    <i>Email is required</i>
                                  </span>
                                </div>
                              </div>
                              <div className="col-md-3">
                                <div className="form-group floating-label">
                                  <input
                                    type="text"
                                    name="PhoneNo"
                                    className="form-control"
                                    placeholder="Phone *"
                                    id="PhoneNo"
                                    maxLength={14}
                                  />
                                  <span className="highlight" />
                                  <span className="bar" />
                                  <span
                                    className="k-form-error k-invalid-msg"
                                    style={{ display: "none" }}
                                    id="err_phone"
                                  >
                                    <i>Phone is required</i>
                                  </span>
                                </div>
                              </div>
                            </div>
                            <div className="div-center">
                              <span
                                style={{
                                  fontSize: 16,
                                  marginBottom: 15,
                                  color: "gray",
                                }}
                              >
                                Choose your Event Type *
                              </span>
                            </div>
                            <div className="row" id="card-events">
                              {Model?.EventsList?.map((item, index) => (
                                <div
                                  className="col-md-3 col-sm-6 col-xs-6"
                                  key={index}
                                >
                                  <div
                                    className="my-card text-center "
                                    style={{ marginTop: "10px" }}
                                    data-id={item.TypeId}
                                    data-name={item.TypeName}
                                  >
                                    <div>
                                      <div
                                        className="div-center"
                                        style={{ marginBottom: "6px" }}
                                      >
                                        <div className="icon-div">
                                          <img
                                            src={item.ImageName}
                                            alt={item.TypeName}
                                            style={{ maxWidth: "70%" }}
                                          />
                                        </div>
                                      </div>
                                      <span className="span-title">
                                        {item.TypeName}
                                      </span>
                                    </div>
                                  </div>
                                </div>
                              ))}
                            </div>
                            <div className="div-center">
                              <span
                                className="k-form-error k-invalid-msg"
                                style={{ display: "none", marginBottom: 15 }}
                                id="err_event"
                              >
                                <i>Please select the Event</i>
                              </span>
                            </div>
                            <div
                              className="row div-center"
                              id="Culture_dd"
                              style={{ display: "none" }}
                            >
                              <div className="col-md-4">
                                <select
                                  className="funl-corporate"
                                  id="Culture"
                                ></select>
                                <span
                                  className="text-danger"
                                  style={{ display: "none" }}
                                  id="err_culture"
                                >
                                  Culture is required
                                </span>
                              </div>
                            </div>
                            <div
                              className="card-functions"
                              style={{ display: "none" }}
                            >
                              <div
                                className="row"
                                id="Pcq"
                                style={{ display: "none" }}
                              >
                                <div
                                  className="col-md-3"
                                  style={{ display: "block" }}
                                >
                                  <div
                                    className="form-group"
                                    id="private-party-corporate"
                                    style={{ display: "none" }}
                                  >
                                    <input id="FunctionName" />
                                    <span
                                      className="k-form-error k-invalid-msg"
                                      style={{ display: "none" }}
                                      id="err_FunctionName"
                                    >
                                      <i>Function type is required</i>
                                    </span>
                                  </div>
                                  <div
                                    className="form-group"
                                    id="Quince"
                                    style={{ display: "none", paddingTop: 10 }}
                                  >
                                    <span
                                      className="event-title"
                                      style={{ height: 30, paddingTop: 10 }}
                                    >
                                      Quinceañera
                                    </span>
                                  </div>
                                  <div
                                    className="form-group"
                                    id="Wedding"
                                    style={{ display: "none", paddingTop: 10 }}
                                  >
                                    <span
                                      className="event-title"
                                      style={{ height: 30, paddingTop: 10 }}
                                    >
                                      Wedding
                                    </span>
                                  </div>
                                </div>
                                <div className="col-md-3">
                                  <div>
                                    <input
                                      className="date-picker"
                                      placeholder="Start Date *"
                                      id="EventDate"
                                    />
                                    <span
                                      className="k-form-error k-invalid-msg"
                                      style={{ display: "none" }}
                                      id="err_FuncEventDate"
                                    >
                                      <i>Start date is required</i>
                                    </span>
                                  </div>
                                </div>
                                <div
                                  className="col-md-6"
                                  style={{ textAlign: "center" }}
                                >
                                  <span
                                    style={{
                                      fontSize: 14,
                                      marginBottom: 15,
                                      color: "gray",
                                    }}
                                  >
                                    No of attendees*
                                  </span>
                                  <div className="my-slider">
                                    <div id="form-wrapper">
                                      <form>
                                        <div id="debt-amount-slider">
                                          {Model.NoofAttendees?.map(
                                            (attendee, index) => (
                                              <>
                                                <input
                                                  type="radio"
                                                  name="pcqNoofattendees"
                                                  data-id={attendee.Value}
                                                  id={`attendee-${index}`}
                                                  value={attendee.Text}
                                                  required
                                                  onChange={(e) =>
                                                    storeNoOfAttendees(e.target)
                                                  }
                                                />
                                                <label
                                                  htmlFor={`attendee-${index}`}
                                                  data-debt-amount={
                                                    attendee.Text
                                                  }
                                                ></label>
                                              </>
                                            )
                                          )}
                                          <input
                                            type="hidden"
                                            id="NoOfAttendees"
                                          />
                                          <div id="debt-amount-pos" />
                                        </div>
                                      </form>
                                    </div>
                                  </div>
                                  <span
                                    className="k-form-error k-invalid-msg"
                                    style={{
                                      display: "none",
                                      marginTop: 12,
                                      marginLeft: 30,
                                    }}
                                    id="err_range"
                                  >
                                    <i>No of attendees is required</i>
                                  </span>
                                </div>
                              </div>
                              <div
                                id="WeddingFunctionList"
                                style={{ display: "none" }}
                              ></div>
                              <span
                                className="k-form-error k-invalid-msg"
                                style={{ display: "none" }}
                                id="err_date_range"
                              >
                                <i>
                                  Select atleast one function with date and no
                                  of attendees
                                </i>
                              </span>
                            </div>
                            <div className="row" style={{ marginTop: 20 }}>
                              <div className="col-md-12">
                                <div className="form-group" id="Ad_comments">
                                  <textarea
                                    id="Additional_details"
                                    className="form-control"
                                    placeholder="Additional details"
                                    defaultValue={""}
                                    onInput={(e) => {
                                      e.target.style.height = "auto"; // Reset height to calculate new height
                                      e.target.style.height = `${e.target.scrollHeight}px`; // Set height to content
                                    }}
                                    style={{
                                      overflow: "auto",
                                      resize: "none",
                                    }}
                                  />
                                </div>
                              </div>
                            </div>

                            <div className="row" style={{ marginTop: 20 }}>
                              <div className="col-md-4">
                                <div
                                  className="form-group"
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    marginBottom: 0,
                                  }}
                                >
                                  <span className="event-title">
                                    Are you planning for multiple day event?
                                  </span>{" "}
                                  &nbsp;&nbsp;
                                  <input
                                    type="checkbox"
                                    className="theme-checkbox"
                                    id="mul_Date_Func"
                                    onChange={(e) =>
                                      MulDatefunchange(e.target.value)
                                    }
                                  />
                                </div>
                                <span></span>
                              </div>
                              <div className="col-md-4">
                                <div
                                  className="form-group"
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                  }}
                                >
                                  <span className="event-title">
                                    Have you been to Meridian recently?
                                  </span>{" "}
                                  &nbsp;&nbsp;
                                  <input
                                    type="checkbox"
                                    className="theme-checkbox"
                                    id="Have-you-been"
                                    onChange={(e) =>
                                      Haveyoubeenchag(e.target.value)
                                    }
                                  />
                                </div>
                              </div>
                              <div className="col-md-4">
                                <select id="hear-about-us"></select>
                                <span
                                  className="k-form-error k-invalid-msg"
                                  style={{ display: "none" }}
                                  id="err_Reference"
                                >
                                  <i>Reference is required</i>
                                </span>
                              </div>
                            </div>
                            <div className="row">
                              <div className="col-md-12">
                                <p
                                  style={{
                                    fontSize: 12,
                                    // textAlign: "left",
                                    marginTop: 20,
                                    // marginBottom: 20,
                                    // lineHeight: 20,
                                  }}
                                >
                                  Not sure about the Dates ? Planning for
                                  Multiple Day/Functions ? Please Call/Text our
                                  Event Specialist at{" "}
                                  <a href="tel:+13362186470">(336) 218-6470</a>
                                </p>
                              </div>
                            </div>
                            <div className="row">
                              <div className="col-md-12">
                                <label style={{ color: "#232323" }}>
                                  What is the sum of: *
                                </label>
                              </div>
                              <div
                                className="col-md-12"
                                style={{
                                  marginTop: "1%",
                                  display: "flex",
                                  justifyContent: "flex-start",
                                  alignItems: "center",
                                }}
                              >
                                <div className="capnum2">
                                  <label
                                    style={{
                                      display: "flex",
                                      color: "#232323",
                                    }}
                                  >
                                    <span
                                      style={{
                                        display: "inherit",
                                        fontSize: 18,
                                      }}
                                      id="Indexrandom1"
                                    />
                                    <span
                                      style={{
                                        display: "inherit",
                                        fontSize: 18,
                                      }}
                                    >
                                      &nbsp;+&nbsp;
                                    </span>
                                    <span
                                      style={{
                                        display: "inherit",
                                        fontSize: 18,
                                      }}
                                      id="Indexrandom2"
                                    />
                                  </label>
                                </div>
                                <div>
                                  <span
                                    style={{
                                      display: "inherit",
                                      fontSize: 30,
                                      marginTop: "-13%",
                                    }}
                                  >
                                    &nbsp;=&nbsp;
                                  </span>
                                </div>
                                <div>
                                  <a style={{ display: "flex" }}>
                                    <div>
                                      <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Enter the sum *"
                                        id="usernumber1"
                                        onChange={handleChange}
                                      />
                                      <span className="highlight" />
                                      <span className="bar" />
                                    </div>
                                    <i
                                      onClick={differentProblem}
                                      style={{
                                        cursor: "pointer",
                                        fontSize: 17,
                                        display: "inherit",
                                        marginTop: "10px",
                                      }}
                                      className="fa fa-refresh"
                                    />
                                  </a>
                                  <span
                                    className="k-form-error k-invalid-msg"
                                    style={{ display: "none" }}
                                    id="err_captcha"
                                  >
                                    <i>Captcha is required</i>
                                  </span>
                                </div>
                              </div>
                            </div>
                          </div>
                          <ul
                            className="list-inline"
                            style={{ textAlign: "right" }}
                          >
                            <li>
                              <button
                                type="button"
                                className="step-btn next-step"
                                id="Step1-Next"
                              >
                                <span>Check Availability</span>
                                <i className="fa fa-chevron-right" />
                              </button>
                            </li>
                          </ul>
                        </div>
                        <div className="tab-pane" role="tabpanel" id="step2">
                          <div className="form-input-steps">
                            <div
                              className="example-item-wrap k-d-flex k-align-items-center k-justify-content-center"
                              id="stepper-loader"
                              style={{ height: 300 }}
                            >
                              <div id="loader-medium" />
                            </div>
                            <div id="stepper-2" style={{ display: "none" }}>
                              <div className="div-center">
                                <span
                                  id="Recommendation_Thankyou"
                                  style={{ marginTop: 10, display: "none" }}
                                />
                              </div>
                              <ul
                                className="list-inline text-center"
                                style={{ marginTop: "-20px" }}
                              >
                                <li>
                                  <button
                                    type="button"
                                    className="step-btn next-step"
                                  >
                                    <span>Book your Tour</span>
                                    <i className="fa fa-chevron-right" />
                                  </button>
                                </li>
                              </ul>
                              <div
                                className="row"
                                style={{ marginTop: 20 }}
                                id="available"
                              >
                                <div className="col-md-8" id="ballroom-img">
                                  <div
                                    className="card card-body"
                                    id="bg-img"
                                    style={{
                                      backgroundImage:
                                        'url("https://meridianconvention.com/PageImages/Banner/20220720021727MSH_MariaSollecito-MKS_1164.jpg")',
                                    }}
                                  >
                                    <div
                                      style={{
                                        textAlign: "start",
                                        marginBottom: 6,
                                        opacity: "0.9",
                                      }}
                                    >
                                      <div className="div-center">
                                        <span
                                          style={{
                                            fontSize: 12,
                                            color: "white",
                                          }}
                                          id="idle-choice"
                                        />
                                      </div>
                                      <div style={{ marginTop: 5 }}>
                                        <span
                                          style={{
                                            fontSize: 22,
                                            fontWeight: "bold",
                                            color: "white",
                                          }}
                                          id="recd-ballroom"
                                        />
                                      </div>
                                      <div
                                        style={{
                                          marginTop: 10,
                                          cursor: "pointer",
                                        }}
                                      >
                                        <div
                                          style={{
                                            padding: "10px 10px",
                                            backgroundColor: "white",
                                            color: "#333",
                                            fontSize: 20,
                                            fontWeight: "bold",
                                            textAlign: "center",
                                            borderRadius: 50,
                                          }}
                                          id="ImageLink"
                                        >
                                          Explore
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div
                                  className="col-md-6"
                                  id="ballroom-img2"
                                  style={{ display: "none" }}
                                >
                                  <div
                                    className="card card-body"
                                    id="bg-img2"
                                    style={{
                                      backgroundImage:
                                        'url("https://meridianconvention.com/PageImages/Banner/20220720021727MSH_MariaSollecito-MKS_1164.jpg")',
                                    }}
                                  >
                                    <div
                                      style={{
                                        textAlign: "start",
                                        marginBottom: 6,
                                        opacity: "0.9",
                                      }}
                                    >
                                      <div className="div-center">
                                        <span
                                          style={{
                                            fontSize: 12,
                                            color: "white",
                                          }}
                                          id="idle-choice2"
                                        />
                                      </div>
                                      <div style={{ marginTop: 5 }}>
                                        <span
                                          style={{
                                            fontSize: 22,
                                            fontWeight: "bold",
                                            color: "white",
                                          }}
                                          id="recd-ballroom2"
                                        />
                                      </div>
                                      <div
                                        style={{
                                          marginTop: 10,
                                          cursor: "pointer",
                                        }}
                                      >
                                        <div
                                          style={{
                                            padding: "10px 10px",
                                            backgroundColor: "white",
                                            color: "#333",
                                            fontSize: 20,
                                            fontWeight: "bold",
                                            textAlign: "center",
                                            borderRadius: 50,
                                          }}
                                          id="ImageLink2"
                                        >
                                          Explore
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div
                                  className="col-md-4"
                                  style={{ display: "none" }}
                                  id="div-calendar"
                                >
                                  <div id="div-calwrapper">
                                    <div
                                      id="kendo-calendar"
                                      style={{ height: "300px!important" }}
                                    />
                                  </div>
                                </div>
                              </div>
                              <div id="Unavailable" style={{ display: "none" }}>
                                <div className="row" style={{ marginTop: 20 }}>
                                  <div
                                    className="col-md-8"
                                    id="Unavailable_ballroom-img"
                                  >
                                    <div
                                      className="card card-body"
                                      id="Unavailable_bg-img"
                                      style={{
                                        backgroundImage:
                                          'url("https://meridianconvention.com/PageImages/Banner/20220720021727MSH_MariaSollecito-MKS_1164.jpg")',
                                      }}
                                    >
                                      <div
                                        style={{
                                          textAlign: "start",
                                          marginBottom: 6,
                                          opacity: "0.9",
                                        }}
                                      >
                                        <div className="div-center">
                                          <span
                                            style={{
                                              fontSize: 12,
                                              color: "white",
                                            }}
                                            id="Unavailable_idle-choice"
                                          />
                                        </div>
                                        <div style={{ marginTop: 5 }}>
                                          <span
                                            style={{
                                              fontSize: 22,
                                              fontWeight: "bold",
                                              color: "white",
                                            }}
                                            id="Unavailable_recd-ballroom"
                                          />
                                        </div>
                                        <div
                                          style={{
                                            marginTop: 10,
                                            cursor: "pointer",
                                          }}
                                        >
                                          <div
                                            style={{
                                              padding: "10px 10px",
                                              backgroundColor: "white",
                                              color: "#333",
                                              fontSize: 20,
                                              fontWeight: "bold",
                                              textAlign: "center",
                                              borderRadius: 50,
                                            }}
                                            id="Unavailable_ImageLink"
                                          >
                                            Explore
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div
                                    className="col-md-4"
                                    id="Unavailable_div-calendar"
                                  >
                                    <div id="Unavailable_div-calwrapper">
                                      <div
                                        id="Unavailable_kendo-calendar"
                                        style={{ height: "300px!important" }}
                                      />
                                    </div>
                                  </div>
                                </div>
                                <div
                                  className="row"
                                  style={{ marginTop: 20 }}
                                  id="Unavailable_Row"
                                >
                                  <div
                                    className="col-md-8"
                                    id="Unavailable_ballroom-img2"
                                  >
                                    <div
                                      className="card card-body"
                                      id="Unavailable_bg-img2"
                                      style={{
                                        backgroundImage:
                                          'url("https://meridianconvention.com/PageImages/Banner/20220720021727MSH_MariaSollecito-MKS_1164.jpg")',
                                      }}
                                    >
                                      <div
                                        style={{
                                          textAlign: "start",
                                          marginBottom: 6,
                                          opacity: "0.9",
                                        }}
                                      >
                                        <div className="div-center">
                                          <span
                                            style={{
                                              fontSize: 12,
                                              color: "white",
                                            }}
                                            id="Unavailable_idle-choice2"
                                          />
                                        </div>
                                        <div style={{ marginTop: 5 }}>
                                          <span
                                            style={{
                                              fontSize: 22,
                                              fontWeight: "bold",
                                              color: "white",
                                            }}
                                            id="Unavailable_recd-ballroom2"
                                          />
                                        </div>
                                        <div
                                          style={{
                                            marginTop: 10,
                                            cursor: "pointer",
                                          }}
                                        >
                                          <div
                                            style={{
                                              padding: "10px 10px",
                                              backgroundColor: "white",
                                              color: "#333",
                                              fontSize: 20,
                                              fontWeight: "bold",
                                              textAlign: "center",
                                              borderRadius: 50,
                                            }}
                                            id="Unavailable_ImageLink2"
                                          >
                                            Explore
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div
                                    className="col-md-4"
                                    id="Unavailable_div-calendar1"
                                  >
                                    <div id="Unavailable_div-calwrapper1">
                                      <div
                                        id="Unavailable_kendo-calendar1"
                                        style={{ height: "300px !important" }}
                                      />
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="div-center">
                                <span
                                  style={{ marginTop: 15, color: "black" }}
                                  id="recd-footer"
                                />
                              </div>
                            </div>
                            <div
                              className="div-center"
                              id="warning"
                              style={{ display: "none" }}
                            >
                              <div>
                                <div style={{ textAlign: "center" }}>
                                  <img
                                    src="/assets/images/exclamation.png"
                                    style={{ width: 40 }}
                                  />
                                </div>
                                <div style={{ marginTop: 3 }}>
                                  <span style={{ color: "gray", fontSize: 22 }}>
                                    Something went wrong
                                  </span>
                                </div>
                                <div style={{ marginTop: 6 }}>
                                  <span style={{ color: "gray", fontSize: 14 }}>
                                    Please try again later
                                  </span>
                                </div>
                              </div>
                            </div>
                            <div
                              className="div-center"
                              id="Server_Error"
                              style={{
                                display: "none",
                                textAlign: "center",
                                height: "400px",
                              }}
                            >
                              <div>
                                <div style={{ textAlign: "center" }}>
                                  <img
                                    src="/assets/images/exclamation.png"
                                    style={{ width: 40 }}
                                  />
                                </div>
                                <div style={{ marginTop: 3 }}>
                                  <span style={{ color: "gray", fontSize: 22 }}>
                                    Server is not responding
                                  </span>
                                </div>
                                <div style={{ marginTop: 6 }}>
                                  <span style={{ color: "gray", fontSize: 14 }}>
                                    Please try again later or reach meridian
                                    through info@meridianconvention.com
                                  </span>
                                </div>
                              </div>
                            </div>
                          </div>
                          <ul
                            className="list-inline"
                            style={{ textAlign: "right" }}
                          >
                            <li>
                              <button
                                type="button"
                                className="step-btn prev-step"
                              >
                                <i className="fa fa-chevron-left" />
                                <span>Back</span>
                              </button>
                            </li>
                            <li>
                              <button
                                type="button"
                                className="step-btn next-step"
                              >
                                <span>Book your Tour</span>
                                <i className="fa fa-chevron-right" />
                              </button>
                            </li>
                          </ul>
                        </div>
                        <div className="tab-pane" role="tabpanel" id="step3">
                          <div className="form-input-steps">
                            <div style={{ width: "100%", height: "500px" }}>
                              <iframe
                                target="_self"
                                src={calendlyLink}
                                title
                                style={{ width: "100%", height: "100%" }}
                              ></iframe>
                            </div>
                          </div>
                          <ul
                            className="list-inline"
                            id="finish-btn"
                            style={{ display: "none", textAlign: "right" }}
                          >
                            <li>
                              <button
                                type="button"
                                className="step-btn next-step"
                              >
                                <span>Finish</span>
                                <i className="fa fa-chevron-right" />
                              </button>
                            </li>
                          </ul>
                          <div
                            style={{ display: "flex", justifyContent: "end" }}
                          >
                            <div style={{ marginRight: 50, marginTop: 10 }}>
                              <div id="loader-finish" />
                            </div>
                          </div>
                        </div>
                        <div className="clearfix" />
                      </div>
                      <div className="wizard-inner" style={{ display: "none" }}>
                        <ul className="nav nav-tabs" role="tablist">
                          <li role="presentation">
                            <a
                              href="#step1"
                              className="active"
                              data-toggle="tab"
                              aria-controls="step1"
                              role="tab"
                              aria-expanded="true"
                              data-step={1}
                            >
                              <span className="round-tab">1</span>
                            </a>
                          </li>
                          <li role="presentation">
                            <a
                              href="#step2"
                              className="disabled"
                              data-toggle="tab"
                              aria-controls="step2"
                              role="tab"
                              aria-expanded="false"
                              data-step={2}
                            >
                              <span className="round-tab">2</span>
                            </a>
                          </li>
                          <li role="presentation">
                            <a
                              href="#step3"
                              className="disabled"
                              data-toggle="tab"
                              aria-controls="step3"
                              role="tab"
                              data-step={3}
                            >
                              <span className="round-tab">3</span>
                            </a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default InquiryPage;
